// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SquareFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SquareFilledIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 3.5h13v13h-13z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const SquareFilledIcon = /* @__PURE__ */ Object.assign(
  SquareFilledIconComponent,
  { displayName: 'SquareFilledIcon' },
);
